import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http'
import { EMPTY, Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import { AuthService } from './auth.service'
import { Injectable, Injector, inject } from '@angular/core'
import { LOAN_STORAGE, SharedService } from './shared.service'
import { environment } from '@environments/environment'
import * as Sentry from '@sentry/angular'

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private injector = inject(Injector)
  private readonly loginUrl = '/dashboard-visa/login'

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthService)
    const router = this.injector.get(Router)
    const sharedData = this.injector.get(SharedService)

    req = req.clone({
      headers: req.headers
        .append('version', '3.0.0')
        .append('service-id', String(environment.serviceId))
        .append('source', environment.appHost),
    })

    if (req.url.includes('/api/') || req.url.includes('/restapi/')) {
      if (authService.isAuthenticated()) {
        req = req.clone({ headers: req.headers.set('Token', authService.user?.token ?? '') })
      }

      req = req.clone({
        headers: req.headers.set('X-CUSTOMER', authService.user ? String(authService.user?.id) : ''),
      })

      const loan = sharedData.getData(LOAN_STORAGE)
      req = req.clone({ headers: req.headers.set('X-LOAN', loan ? String(loan.id) : '') })
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let throwErrorFlag = false
        switch (error.status) {
          case HttpStatusCode.InternalServerError:
          case HttpStatusCode.ServiceUnavailable:
          case HttpStatusCode.BadRequest:
            Sentry.captureException(error, {
              tags: {
                http_status: String(error.status),
              },
              extra: {
                method: req.method,
                requestUrl: req.urlWithParams,
              },
            })
            break
          case HttpStatusCode.Forbidden:
          case HttpStatusCode.Unauthorized:
            if (!req.url.includes('/api/public/') && !router.url.startsWith(this.loginUrl)) {
              authService.logout()
              router.navigate([this.loginUrl], { queryParams: { logout: true } })
              break
            }
            throwErrorFlag = true
            break
          default:
            throwErrorFlag = true
        }
        return throwErrorFlag ? throwError(() => error) : EMPTY
      }),
    )
  }
}
